import { resetAppState } from "./appSlice";
import { resetAccountState } from "./createAccountSlice";
import { resetBrowsePageState } from "./createBrowsePageSlice";
import { resetGigProposalState } from "./createGigProposalSlice";
import { resetCreateGigState } from "./createGigSlice";
import { resetGoogleMapState } from "./createGoogleMapSlice";
import { resetProfilePageState } from "./createProfilePageSlice";
import { resetSidebarState } from "./createSidebarSlice";
import { resetFinancePropsState } from "./financeSlice";
import { resetGigAndProposalState } from "./gigsAndProposalsSlice";
import { resetMessageState } from "./messagingSlice";
import { store } from "./store";
import { resetUserState } from "./userSlice";

const resetReduxState = () => {
  store.dispatch(resetProfilePageState());
  store.dispatch(resetFinancePropsState());
  store.dispatch(resetSidebarState());
  store.dispatch(resetUserState());
  store.dispatch(resetAccountState());
  store.dispatch(resetBrowsePageState());
  store.dispatch(resetGigAndProposalState());
  store.dispatch(resetGigProposalState());
  store.dispatch(resetCreateGigState());
  store.dispatch(resetGoogleMapState());
  store.dispatch(resetMessageState());
  store.dispatch(resetAppState());
};

export default resetReduxState;
